import {
  LOAD_SUCCESS_IMMEUBLES,
  LOAD_FAIL_IMMEUBLES,
  SAVE_SUCCESS_IMMEUBLES,
  SAVE_FAIL_IMMEUBLES,
  UPDATE_SUCCESS_IMMEUBLES,
  UPDATE_FAIL_IMMEUBLES,
  DELETE_SUCCESS_IMMEUBLES,
  DELETE_FAIL_IMMEUBLES,
} from "../actions/immeubleAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_IMMEUBLES:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_IMMEUBLES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_IMMEUBLES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_IMMEUBLES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_IMMEUBLES:
      const updatedListe = [];
      state.data.forEach((item) => {
        if (item.immeuble_id === action.payload.immeuble_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_IMMEUBLES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_IMMEUBLES:
      const filtered = state.data.filter((etape) => {
        return etape.immeuble_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_IMMEUBLES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
